function Attachment() {
    this.id = null;
    this.filename = null;

    // ui support
    this.isComplete = true;
    this.isInProgress = false;
    this.percentCompleted = 100;
}

Attachment.prototype.TYPE_DEBT_OVERVIEW = 'DEBT_OVERVIEW';
Attachment.prototype.TYPE_SAVINGS_STATEMENT = 'SAVINGS_STATEMENT';
Attachment.prototype.TYPE_BANK_STATEMENT = 'BANK_STATEMENT';
Attachment.prototype.TYPE_INCOME_SPECIFICATION = 'INCOME_SPECIFICATION';
Attachment.prototype.TYPE_SPECIAL_WELFARE_CONTACT = 'SPECIAL_WELFARE_CONTACT';
Attachment.prototype.TYPE_HEALTH_INSURANCE_POLICY = 'HEALTH_INSURANCE_POLICY';
Attachment.prototype.TYPE_SOCIAL_SUPPORT_ACT = 'SOCIAL_SUPPORT_ACT';
Attachment.prototype.TYPE_MEDICAL_CONSENT = 'MEDICAL_CONSENT';
Attachment.prototype.TYPE_EDUCATION_CONTRACT = 'EDUCATION_CONTRACT';
Attachment.prototype.TYPE_QUOTATION = 'QUOTATION';

Attachment.prototype.TYPES = [
    Attachment.prototype.TYPE_DEBT_OVERVIEW,
    Attachment.prototype.TYPE_SAVINGS_STATEMENT,
    Attachment.prototype.TYPE_BANK_STATEMENT,
    Attachment.prototype.TYPE_INCOME_SPECIFICATION,
    Attachment.prototype.TYPE_SPECIAL_WELFARE_CONTACT,
    Attachment.prototype.TYPE_HEALTH_INSURANCE_POLICY,
    Attachment.prototype.TYPE_SOCIAL_SUPPORT_ACT,
    Attachment.prototype.TYPE_MEDICAL_CONSENT,
    Attachment.prototype.TYPE_EDUCATION_CONTRACT,
    Attachment.prototype.TYPE_QUOTATION,
];

export default Attachment;
